import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _omit from "lodash/omit";
import _forEach from "lodash/forEach";
var _excluded = ["options", "innerRef"];
import "core-js/modules/es6.array.map.js";
import React, { Component } from 'react';
import { DropdownTrigger } from './DropdownTrigger';
import { SELECT_DEFAULT_PROPS } from './prop-types'; // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration

var Option = function Option(_ref) {
  var disabled = _ref.disabled,
      label = _ref.label,
      value = _ref.value;
  return /*#__PURE__*/React.createElement("option", {
    value: value !== null && value !== void 0 ? value : label,
    disabled: disabled
  }, label);
};

Option.displayName = 'Option';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _require = require('./prop-types'),
      OPTION_PROPS = _require.OPTION_PROPS;

  Option.propTypes = OPTION_PROPS;
} // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration


var OptGroup = function OptGroup(_ref2) {
  var title = _ref2.title,
      options = _ref2.options;
  return /*#__PURE__*/React.createElement("optgroup", {
    label: title,
    key: title
  }, options.map(function (o) {
    var _o$value;

    return /*#__PURE__*/React.createElement(Option, _extends({}, o, {
      key: (_o$value = o.value) !== null && _o$value !== void 0 ? _o$value : o.label
    }));
  }));
};

OptGroup.displayName = 'OptGroup';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _require2 = require('./prop-types'),
      OPTION_GROUP_PROPS = _require2.OPTION_GROUP_PROPS;

  OptGroup.propTypes = OPTION_GROUP_PROPS;
}
/**
 * Renders a native select component.
 */


export var NativeSelect = /*#__PURE__*/function (_Component) {
  _inherits(NativeSelect, _Component);

  var _super = _createSuper(NativeSelect);

  function NativeSelect() {
    var _this;

    _classCallCheck(this, NativeSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOptionChange", function (e) {
      // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
      if (!_this.props.multiple) {
        // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
        _this.props.onChange(e);

        return; // short circuit to ensure onChange is only called once for native Select arrays
      }
      /*
        onChange should send back an array for multiple values
      */


      var value = [];

      if (e.target.options) {
        var options = e.target.options;

        _forEach(options, function (option) {
          if (option.selected) {
            value.push(option.value);
          }
        });
      } // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration


      _this.props.onChange({
        target: {
          value: value
        }
      });
    });

    return _this;
  }

  _createClass(NativeSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          innerRef = _this$props.innerRef,
          otherProps = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement(DropdownTrigger, _extends({}, _omit(otherProps, ['onChange']), {
        onChange: this.handleOptionChange,
        mode: "select",
        ref: innerRef
      }), options.map(function (option) {
        var _option$value;

        return option.options ? /*#__PURE__*/React.createElement(OptGroup, _extends({}, option, {
          key: option.title
        })) : /*#__PURE__*/React.createElement(Option, _extends({}, option, {
          key: (_option$value = option.value) !== null && _option$value !== void 0 ? _option$value : option.label
        }));
      }));
    }
  }]);

  return NativeSelect;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

NativeSelect.displayName = 'NativeSelect';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _require3 = require('./prop-types'),
      SELECT_PROP_TYPES = _require3.SELECT_PROP_TYPES; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  NativeSelect.propTypes = SELECT_PROP_TYPES;
} // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


NativeSelect.defaultProps = SELECT_DEFAULT_PROPS;